export const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  modalContent: {
    width: 360,
    maxWidth: "90%",
    maxHeight: "80vh",
    backgroundColor: "#fff",
    borderRadius: 8,
    padding: 24,
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
    overflowY: "auto",
  },
  header: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 16,
    marginBottom: 16,
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    border: "none",
    background: "transparent",
    fontSize: 20,
    cursor: "pointer",
    color: "#999",
  },
  groupImage: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    objectFit: "cover",
  },
  groupPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  groupTitle: {
    marginTop: 12,
    fontSize: 18,
    textAlign: "center",
  },
  participantsList: {
    overflow: "visible",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
  },
  participant: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "6px 8px",
    borderRadius: 6,
    cursor: "default",
    backgroundColor: "#f9f9f9",
    position: "relative",
  },
  participantIcon: {
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#E5E7EB",
    borderRadius: "50%",
  },
  participantName: {
    fontSize: 14,
    color: "#333",
  },
  participantMenuButton: {
    marginLeft: "auto",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: 16,
    color: "#666",
  },
  participantDropdown: {
    position: "fixed",
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: 6,
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    width: 160,
    zIndex: 9999,
  },
  participantDropdownItem: {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: 14,
    color: "#333",
    borderRadius: 4,
    transition: "background 0.2s",
    display: "flex",
    alignItems: "center"
  },
  participantDropdownItemHover: {
    backgroundColor: "#f5f5f5",
  },
  addButton: {
    marginTop: 16,
    padding: "8px 12px",
    backgroundColor: "#638165",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 6,
    alignSelf: "stretch",
    justifyContent: "center",
  },

  actionButtons: {
    marginTop: 12,
    display: "flex",
    gap: 8,
    width: "100%",
    justifyContent: "center",
  },
  button: (primary, disabled = false) => ({
    padding: "10px 14px",
    minWidth: 160,
    borderRadius: 6,
    border: primary ? "none" : "1px solid #ccc",
    background: primary ? "#1F3A70" : "#f5f5f5",
    color: primary ? "#fff" : "#000",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.7 : 1,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
  }),
};